import React from 'react';
import { motion } from 'framer-motion';
import { Logo } from '../Logo';
import type { SlideProps } from './SlideShell';
export function Slide17Closing({
  index
}: SlideProps) {
  return <div className="relative w-full h-full overflow-hidden bg-white" data-id="element-70" data-mp="7f2cfr4843c9">
      {/* Hero image with pharmaceutical overlay */}
      <div className="absolute inset-0" data-id="element-71" data-mp="cd3zso8omotj">
        <motion.img src="https://cdn.magicpatterns.com/patterns/generated-images/2d414841-3abc-4bfd-a925-83c9b2cd3bde.jpg" alt="Abstract brain-health illustration" className="w-full h-full object-cover" initial={{
        scale: 1.05
      }} animate={{
        scale: 1
      }} transition={{
        duration: 10,
        ease: 'easeOut'
      }} data-id="element-72" data-mp="cbstohrrl4z9" />
        <div className="absolute inset-0 bg-white/35" data-id="element-73" data-mp="1itoagg3pt9zs" />
      </div>

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col items-center justify-center px-[clamp(2rem,6vw,6rem)] text-center" data-id="element-74" data-mp="1ntkeuggbr3fv">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.2,
        duration: 0.6
      }} className="mb-8" data-id="element-75" data-mp="1r1amzkmu90i5">
          <div className="w-24 h-24 rounded-full bg-[var(--surface)] border-4 border-white shadow-xl flex items-center justify-center mx-auto mb-6" data-id="element-76" data-mp="1vttzsfdpbrlw">
            <svg className="w-12 h-12 text-[var(--brand)]" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-77" data-mp="134wh4b5kvssm">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" data-id="element-78" data-mp="1h21m07tk2lma" />
            </svg>
          </div>
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.4,
        duration: 0.6
      }} className="text-[var(--fg)] font-bold text-[clamp(2rem,4vw,3.5rem)] leading-[1.1] tracking-tight max-w-4xl mb-6" data-id="element-79" data-mp="1l7lf3lbbicnn">
          A scalable model for making brand engagement feel active again
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.55,
        duration: 0.6
      }} className="text-[var(--muted)] text-[clamp(1.1rem,1.5vw,1.4rem)] font-medium max-w-3xl leading-relaxed mb-12" data-id="element-80" data-mp="16hwcdlnku0l9">
          Snakker gives Lundbeck a practical way to turn the brand portfolio's
          monthly digital campaigns into interactive HCP experiences — one
          repeatable model across every brand and market.
        </motion.p>
      </div>

      {/* Co-brand footer row */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1,
      duration: 0.6
    }} className="absolute bottom-[clamp(1.5rem,3vh,2.5rem)] left-[clamp(2rem,6vw,6rem)] right-[clamp(2rem,6vw,6rem)] z-10 flex items-center justify-between gap-4" data-id="element-81" data-mp="b9vizobmwpui">
        <Logo width={100} data-id="element-82" data-mp="3on6xwzmcwy5b" />
        <div className="flex items-center gap-3" data-id="element-83" data-mp="3olvskvd9jic3">
          <span className="px-3 py-1 bg-[var(--brand)] text-white text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-84" data-mp="3jo446bbtuecn">
            Lundbeck
          </span>
          <span className="px-3 py-1 bg-white border border-black/10 text-[var(--fg)] text-xs font-bold rounded-full uppercase tracking-wider" data-id="element-85" data-mp="3eny90l6cm9pt">
            Brand Portfolio
          </span>
        </div>
      </motion.div>
    </div>;
}